module.exports = __webpack_public_path__ + "img/anatoli.a__600x600.d4860c14.jpg";